import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";

const styles = {
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  section: {
    color: "#005458",
    fontWeight: "bold",
    paddingTop: 10,
    paddingBottom: 10,
    textDecoration: "underline"
  },
  listContainer: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.875rem",
    fontFamily: "Noto Sans",
    fontWeight: "400",
    lineHeight: "1.5"
  }
};

class DataPolicy extends Component {
  state = {};
  render() {
    const { classes } = this.props;
    return (
      <Dialog
        onClose={this.props.handleClose}
        aria-labelledby="data-policy-dialog-title"
        open={this.props.open}
      >
        <DialogTitle
          id="data-policy-dialog-title"
          onClose={this.props.handleClose}
        >
          Data Policy
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" component="p">
            As part of our responsibility to you, the user of the NTRAC
            platform, we want to convey how important stewardship of your data
            is to our company. In joining our platform, you own your data and we
            believe it is important that you have a choice for how that data is
            used for improving the NTRAC platform and may be used to provide
            monetary and information return to you, our user.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            Our Terms and Conditions allow you to participate in initiatives for
            returning added value to you, our user, by anonymously pooling and
            sharing aggregated information with third parties. Such initiatives
            will never include the sharing of your personal data outside of
            NTRAC. If you, the user, select the opt out provision below, this
            allows you, the user, to still use your selected subscription plan
            but will not allow participation in the previously mentioned
            initiatives that return added value, monetary or otherwise, to you.
            If you do choose to opt out at this time, NTRAC reserves the right
            to offer this opportunity again in the future.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            Your personal data is not part of any agreement to be shared outside
            of NTRAC.{" "}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DataPolicy);



// WEBPACK FOOTER //
// ./src/components/public/DataPolicy.js